import React from 'react'
import { withRouter } from 'react-router-dom'

import firebase from 'services/firebase'

import { withStyles } from '@material-ui/core/styles'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import Typography from '@material-ui/core/Typography'
import IconButton from '@material-ui/core/IconButton'
import Icon from '@material-ui/core/Icon'

import getRouteTitle from 'helpers/nav/get-route-title'
import firstString from 'helpers/conditional/first-string'
import styles from 'styles/components/Header'

class Header extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      title: getRouteTitle(props.location.pathname),
      anchorEl: null
    }

    this.props.history.listen(location => {
      this.setState({
        title: getRouteTitle(location.pathname)
      })
    })
  }

  handleUserMenuAction = action => () => {
    this.setState({ anchorEl: null }, () => {
      setTimeout(action, 50)
    })
  }

  handleOpenUserMenu = event => {
    this.setState({ anchorEl: event.currentTarget })
  }

  handleCloseUserMenu = () => {
    this.setState({ anchorEl: null })
  }

  render() {
    const { title, anchorEl } = this.state
    const { classes, editUser, toggle, user } = this.props

    const open = Boolean(anchorEl)

    return (
      <React.Fragment>
        <AppBar className={classes.appBar}>
          <Toolbar>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              onClick={toggle}
              className={classes.navIconHide}
            >
              <Icon>menu</Icon>
            </IconButton>

            <div className={classes.headerSpreader}>
              <Typography variant="title" color="inherit" noWrap>
                {title}
              </Typography>
              <div className={classes.userBlock}>
                <Typography color="inherit">
                  {firstString(user.displayName, user.email)}
                </Typography>
                <IconButton
                  aria-owns={open ? 'menu-appbar' : null}
                  aria-haspopup="true"
                  onClick={this.handleOpenUserMenu}
                  color="inherit"
                >
                  <Icon>account_circle</Icon>
                </IconButton>
                <Menu
                  id="menu-appbar"
                  anchorEl={anchorEl}
                  anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right'
                  }}
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right'
                  }}
                  open={open}
                  onClose={this.handleCloseUserMenu}
                >
                  <MenuItem onClick={this.handleUserMenuAction(editUser)}>
                    Profile
                  </MenuItem>
                  <MenuItem
                    onClick={this.handleUserMenuAction(() => {
                      firebase.auth().signOut()
                    })}
                  >
                    Sign Out
                  </MenuItem>
                </Menu>
              </div>
            </div>
          </Toolbar>
        </AppBar>
      </React.Fragment>
    )
  }
}

export default withStyles(styles, { withTheme: true })(withRouter(Header))



// WEBPACK FOOTER //
// ./src/components/Frame/Header.jsx